/**
 * 各种画echarts图表的方法都封装在这里
 * 注意：这里echarts没有采用按需引入的方式，只是为了方便学习
 */

import echarts from 'echarts'
import tangshan from '@/assets/tangshan.json'
const install = function(Vue) {
    Object.defineProperties(Vue.prototype, {
        $chart: {
            get() {
                return {
                    // 画一条简单的线
                    line1: function(id, datanew) {
                        echarts.registerMap('tangshan', tangshan)
                        this.chart = echarts.init(document.getElementById(id));
                        this.chart.clear();
                        console.log(datanew, '3')
                        const optionData = {
                            baseOption: {
                                tooltip: {
                                    trigger: 'item',
                                    formatter: function(e) {
                                        var html = ''
                                        if (e.data.iState == 1) {
                                            html = "<div style='width:220px;height:110px;border-radius:5px;border:1px solid #fd5705;background:#fff;margin:-5px;text-align:center;padding-top:10px'><img src='" + e.data.nvcNodeLogo + "' style='width=203px;height:76px'><br><span class='color_sub' style='padding-top:5px;display:block' >进入" + e.data.name + '</span></div>'
                                        } else {
                                            html = "<div style='width:220px;height:80px;border-radius:5px;border:1px solid #fd5705;background:#fff;color:#000;text-align:center;padding-top:25px;margin:-5px;'><i class='iconfont icon-warning color_sub f40'></i><br><span style='padding-top:10px;display:block'>此节点暂未开通服务</span></div>"
                                        }
                                        return html
                                    }
                                },
                                visualMap: {
                                    min: 1,
                                    max: 6,
                                    show: false,
                                    calculable: true,
                                    inRange: {
                                        color: ['#fed3e6', '#c6cde7', '#ecf7c7', '#f3e0b8', '#c5e6d3', '#fffbde']
                                    }
                                },
                                geo: {
                                    label: {
                                        show: true,
                                        fontSize: '16px',
                                        color: '#000'
                                    }
                                },

                                series: [{
                                    name: '热图',
                                    type: 'map',
                                    mapType: 'tangshan',
                                    zoom: 1.2,
                                    data: datanew,
                                    label: {
                                        show: true
                                    }
                                }]

                            }
                        }

                        this.chart.setOption(optionData);
                        this.chart.on('click', function(params) {
                            console.log(params, '点击')
                            if (params.data.iState == 1) {
                                debugger
                                if (params.data.name == '物流开平') {
                                    window.open('http://' + 'kaiping.' + '560315.com/', '_blank')
                                } else if (params.data.name == '物流路南') {
                                    window.open('http://' + 'lunan.' + '560315.com/', '_blank')
                                } else if (params.data.name == '物流路北') {
                                    window.open('http://' + 'lubei.' + '560315.com/', '_blank')
                                } else if (params.data.name == '物流丰润') {
                                    window.open('http://' + 'fengrun.' + '560315.com/', '_blank')
                                } else if (params.data.name == '物流丰南') {
                                    window.open('http://' + 'fengnan.' + '560315.com/', '_blank')
                                } else if (params.data.name == '物流古冶') {
                                    window.open('http://' + 'guye.' + '560315.com/', '_blank')
                                } else if (params.data.name == '物流曹妃甸') {
                                    window.open('http://' + 'caofeidian.' + '560315.com/', '_blank')
                                } else if (params.data.name == '物流迁安') {
                                    window.open('http://' + 'qianan.' + '560315.com/', '_blank')
                                } else if (params.data.name == '物流遵化') {
                                    window.open('http://' + 'zunhua.' + '560315.com/', '_blank')
                                } else if (params.data.name == '物流迁西') {
                                    window.open('http://' + 'qianxi.' + '560315.com/', '_blank')
                                } else if (params.data.name == '物流玉田') {
                                    window.open('http://' + 'yutian.' + '560315.com/', '_blank')
                                } else if (params.data.name == '物流滦县') {
                                    window.open('http://' + 'luanxian.' + '560315.com/', '_blank')
                                } else if (params.data.name == '物流滦南') {
                                    window.open('http://' + 'luannan.' + '560315.com/', '_blank')
                                } else if (params.data.name == '物流乐亭') {
                                    window.open('http://' + 'laoting.' + '560315.com/', '_blank')
                                }
                            }
                        })
                    }
                }
            }
        }
    })
}

export default {
    install
}


// WEBPACK FOOTER //
// ./src/assets/myCharts.js